import { useState } from 'react';

import type { HotelPageState } from '@/interfaces';
import displayValues from '@/assets/displayValues.json';

export type HotelFeaturesProps = Pick<HotelPageState, 'features'>;

export const HotelFeatures = ({ features }: HotelFeaturesProps) => {
    const [expanded, setExpanded] = useState(false);
    const enabledFeatures = (features || []).map((feature) => displayValues.features[feature]).filter((feature) => feature?.enabled);
    const featuresWithoutDuplicates = enabledFeatures.filter(
        (feature, index) => enabledFeatures.findIndex((elem) => elem.displayName === feature.displayName) === index,
    );
    const parseValueForAttriute = (displayName: string) => displayName.toLowerCase().replace(/[\s/]/g, '-');
    const displayedFeatures =
        !expanded && featuresWithoutDuplicates.length > 6 ? featuresWithoutDuplicates.slice(0, 6) : featuresWithoutDuplicates;

    if (featuresWithoutDuplicates.length === 0) {
        return null;
    }

    return (
        <div className="u-border-vertical-solid u-pv16">
            <h2 className="hotel-page-subheader">Fasiliteter</h2>
            <div data-testid="feature-list" className="grid">
                {displayedFeatures.map((feature) => (
                    <div
                        key={`feature-${parseValueForAttriute(feature.name)}`}
                        data-testid={`feature-${parseValueForAttriute(feature.name)}`}
                        className="grid__unit u-size1of2 u-mv4 flex flex-row flex-align-center">
                        <i className={`icon icon--medium ${feature.icon} u-mr16`} /> <span className="u-mt2">{feature.displayName}</span>
                    </div>
                ))}
            </div>
            {featuresWithoutDuplicates.length > 6 && (
                <button
                    type="button"
                    data-testid="feature-list-button"
                    className="button button--link u-mt16"
                    onClick={(): void => setExpanded(!expanded)}>
                    {expanded ? 'Færre fasiliteter' : 'Flere fasiliteter...'}
                </button>
            )}
        </div>
    );
};
